import base from "/opt/build/repo/images/pause.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");